/* eslint max-lines: "off" */
// max-lines lint rule does not apply since this is css

import { css } from 'styled-components'

import { color } from 'styles/colors'

export const icons = css`
  [class^="icon-"], [class*=" icon-"] {
    font-family: 'Nexia-IcoFont';
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-triangle-solid:before {
    content: "\\E63F";
  }
  .icon-circle-solid:before {
    content: "\\E640";
  }
  .icon-battery:before {
    content: "\\E602";
  }
  .icon-battery2:before {
    content: "\\E603";
  }
  .icon-battery-full:before {
    content: "\\E604";
  }
  .icon-unlocked:before {
    content: "\\E605";
  }
  .icon-key:before {
    content: "\\E606";
  }
  .icon-play-sign:before {
    content: "\\E607";
  }
  .icon-share-sign:before {
    content: "\\E608";
  }
  .icon-edit-sign:before {
    content: "\\E609";
  }
  .icon-check-sign:before {
    content: "\\E60A";
  }
  .icon-circle-blank:before {
    content: "\\E60B";
  }
  .icon-stethoscope:before {
    content: "\\E60C";
  }
  .icon-circle:before {
    content: "\\E60D";
  }
  .icon-ban-circle:before {
    content: "\\E60E";
  }
  .icon-ok-circle:before {
    content: "\\E60F";
  }
  .icon-remove-circle:before {
    content: "\\E610";
  }
  .icon-uniF000:before {
    content: "\\F000";
  }
  .icon-cord:before {
    content: "\\E000";
  }
  .icon-camera:before {
    content: "\\E001";
  }
  .icon-shield:before {
    content: "\\E002";
  }
  .icon-locked:before {
    content: "\\E003";
  }
  .icon-night:before {
    content: "\\E004";
  }
  .icon-snowflake:before {
    content: "\\E005";
  }
  .icon-heart:before {
    content: "\\E006";
  }
  .icon-star:before {
    content: "\\E007";
  }
  .icon-droplet:before {
    content: "\\E008";
  }
  .icon-sunny:before {
    content: "\\E009";
  }
  .icon-leaf:before {
    content: "\\E00A";
  }
  .icon-bell:before {
    content: "\\E00B";
  }
  .icon-house:before {
    content: "\\E00C";
  }
  .icon-moon:before {
    content: "\\E00D";
  }
  .icon-heart2:before {
    content: "\\E00E";
  }
  .icon-light-bulb:before {
    content: "\\E00F";
  }
  .icon-droplets:before {
    content: "\\E011";
  }
  .icon-star2:before {
    content: "\\F005";
  }
  .icon-heart3:before {
    content: "\\F004";
  }
  .icon-home:before {
    content: "\\F015";
  }
  .icon-lock:before {
    content: "\\F023";
  }
  .icon-lightbulb:before {
    content: "\\F0EB";
  }
  .icon-sun:before {
    content: "\\F185";
  }
  .icon-moon2:before {
    content: "\\F186";
  }
  .icon-image:before {
    content: "\\E013";
  }
  .icon-alarm:before {
    content: "\\E014";
  }
  .icon-speaker:before {
    content: "\\E015";
  }
  .icon-modem:before {
    content: "\\E016";
  }
  .icon-laptop:before {
    content: "\\E017";
  }
  .icon-monitor:before {
    content: "\\E018";
  }
  .icon-mobile:before {
    content: "\\E019";
  }
  .icon-phone:before {
    content: "\\E01A";
  }
  .icon-server:before {
    content: "\\E01B";
  }
  .icon-window:before {
    content: "\\E01C";
  }
  .icon-pictures:before {
    content: "\\E01D";
  }
  .icon-eye:before {
    content: "\\E01E";
  }
  .icon-tv:before {
    content: "\\E01F";
  }
  .icon-camera2:before {
    content: "\\E020";
  }
  .icon-broadcast:before {
    content: "\\E021";
  }
  .icon-broadcast2:before {
    content: "\\E022";
  }
  .icon-earth:before {
    content: "\\E023";
  }
  .icon-search:before {
    content: "\\E024";
  }
  .icon-zoom-out:before {
    content: "\\E025";
  }
  .icon-zoom-in:before {
    content: "\\E026";
  }
  .icon-support:before {
    content: "\\E027";
  }
  .icon-settings:before {
    content: "\\E028";
  }
  .icon-cloud:before {
    content: "\\E029";
  }
  .icon-lightning:before {
    content: "\\E02A";
  }
  .icon-umbrella:before {
    content: "\\E02B";
  }
  .icon-car:before {
    content: "\\E02C";
  }
  .icon-direction:before {
    content: "\\E02D";
  }
  .icon-refresh:before {
    content: "\\E02E";
  }
  .icon-compass:before {
    content: "\\E02F";
  }
  .icon-map:before {
    content: "\\E030";
  }
  .icon-key2:before {
    content: "\\E031";
  }
  .icon-droplet2:before {
    content: "\\E032";
  }
  .icon-earth2:before {
    content: "\\E033";
  }
  .icon-adjust:before {
    content: "\\E034";
  }
  .icon-sun2:before {
    content: "\\E035";
  }
  .icon-sun3:before {
    content: "\\E036";
  }
  .icon-minus:before {
    content: "\\E037";
  }
  .icon-plus:before {
    content: "\\E038";
  }
  .icon-question:before {
    content: "\\E039";
  }
  .icon-help:before {
    content: "\\E03A";
  }
  .icon-info:before {
    content: "\\E03B";
  }
  .icon-warning:before {
    content: "\\E03C";
  }
  .icon-pictures2:before {
    content: "\\E03D";
  }
  .icon-arrow-left:before {
    content: "\\E03E";
  }
  .icon-arrow-down:before {
    content: "\\E03F";
  }
  .icon-arrow-left2:before {
    content: "\\E040";
  }
  .icon-arrow-down2:before {
    content: "\\E041";
  }
  .icon-arrow-up:before {
    content: "\\E042";
  }
  .icon-arrow-right:before {
    content: "\\E043";
  }
  .icon-arrow-up2:before {
    content: "\\E044";
  }
  .icon-arrow-right2:before {
    content: "\\E045";
  }
  .icon-arrow-left3:before {
    content: "\\E046";
  }
  .icon-arrow-down3:before {
    content: "\\E047";
  }
  .icon-arrow-up3:before {
    content: "\\E048";
  }
  .icon-arrow-right3:before {
    content: "\\E049";
  }
  .icon-arrow-left4:before {
    content: "\\E04A";
  }
  .icon-arrow-down4:before {
    content: "\\E04B";
  }
  .icon-arrow-up4:before {
    content: "\\E04C";
  }
  .icon-uniE04D:before {
    content: "\\E04D";
  }
  .icon-menu:before {
    content: "\\E04E";
  }
  .icon-ok:before {
    content: "\\F00C";
  }
  .icon-remove:before {
    content: "\\F00D";
  }
  .icon-time:before {
    content: "\\F017";
  }
  .icon-refresh2:before {
    content: "\\F021";
  }
  .icon-repeat:before {
    content: "\\F01E";
  }
  .icon-adjust2:before {
    content: "\\F042";
  }
  .icon-tint:before {
    content: "\\F043";
  }
  .icon-facetime-video:before {
    content: "\\F03D";
  }
  .icon-chevron-left:before {
    content: "\\F053";
  }
  .icon-chevron-right:before {
    content: "\\F054";
  }
  .icon-plus-sign:before {
    content: "\\F055";
  }
  .icon-minus-sign:before {
    content: "\\F056";
  }
  .icon-remove-sign:before {
    content: "\\F057";
  }
  .icon-ok-sign:before {
    content: "\\F058";
  }
  .icon-question-sign:before {
    content: "\\F059";
  }
  .icon-info-sign:before {
    content: "\\F05A";
  }
  .icon-arrow-left5:before {
    content: "\\F060";
  }
  .icon-arrow-right4:before {
    content: "\\F061";
  }
  .icon-arrow-up5:before {
    content: "\\F062";
  }
  .icon-arrow-down5:before {
    content: "\\F063";
  }
  .icon-plus2:before {
    content: "\\F067";
  }
  .icon-minus2:before {
    content: "\\F068";
  }
  .icon-exclamation-sign:before {
    content: "\\F06A";
  }
  .icon-chevron-up:before {
    content: "\\F077";
  }
  .icon-chevron-down:before {
    content: "\\F078";
  }
  .icon-retweet:before {
    content: "\\F079";
  }
  .icon-comments:before {
    content: "\\F086";
  }
  .icon-rss:before {
    content: "\\F09E";
  }
  .icon-globe:before {
    content: "\\F0AC";
  }
  .icon-group:before {
    content: "\\F0C0";
  }
  .icon-reorder:before {
    content: "\\F0C9";
  }
  .icon-caret-down:before {
    content: "\\F0D7";
  }
  .icon-caret-up:before {
    content: "\\F0D8";
  }
  .icon-caret-left:before {
    content: "\\F0D9";
  }
  .icon-caret-right:before {
    content: "\\F0DA";
  }
  .icon-sort-down:before {
    content: "\\F0DD";
  }
  .icon-sort-up:before {
    content: "\\F0DE";
  }
  .icon-sort:before {
    content: "\\F0DC";
  }
  .icon-dashboard:before {
    content: "\\F0E4";
  }
  .icon-undo:before {
    content: "\\F0E2";
  }
  .icon-bell-alt:before {
    content: "\\F0F3";
  }
  .icon-coffee:before {
    content: "\\F0F4";
  }
  .icon-suitcase:before {
    content: "\\F0F2";
  }
  .icon-double-angle-left:before {
    content: "\\F100";
  }
  .icon-double-angle-right:before {
    content: "\\F101";
  }
  .icon-double-angle-up:before {
    content: "\\F102";
  }
  .icon-double-angle-down:before {
    content: "\\F103";
  }
  .icon-angle-left:before {
    content: "\\F104";
  }
  .icon-angle-right:before {
    content: "\\F105";
  }
  .icon-angle-up:before {
    content: "\\F106";
  }
  .icon-angle-down:before {
    content: "\\F107";
  }
  .icon-expand-alt:before {
    content: "\\F116";
  }
  .icon-folder-open-alt:before {
    content: "\\F115";
  }
  .icon-folder-close-alt:before {
    content: "\\F114";
  }
  .icon-collapse-alt:before {
    content: "\\F117";
  }
  .icon-smile:before {
    content: "\\F118";
  }
  .icon-frown:before {
    content: "\\F119";
  }
  .icon-meh:before {
    content: "\\F11A";
  }
  .icon-question2:before {
    content: "\\F128";
  }
  .icon-info2:before {
    content: "\\F129";
  }
  .icon-exclamation:before {
    content: "\\F12A";
  }
  .icon-shield2:before {
    content: "\\F132";
  }
  .icon-calendar-empty:before {
    content: "\\F133";
  }
  .icon-calendar:before {
    content: "\\F137";
  }
  .icon-chevron-sign-right:before {
    content: "\\F138";
  }
  .icon-chevron-sign-up:before {
    content: "\\F139";
  }
  .icon-chevron-sign-down:before {
    content: "\\F13A";
  }
  .icon-chevron-sign-left:before {
    content: "\\F142";
  }
  .icon-check-sign2:before {
    content: "\\F14A";
  }
  .icon-check-minus:before {
    content: "\\F147";
  }
  .icon-share-sign2:before {
    content: "\\F14D";
  }
  .icon-droplet3:before {
    content: "\\E04F";
  }
  .icon-pacman:before {
    content: "\\E050";
  }
  .icon-dice:before {
    content: "\\E051";
  }
  .icon-history:before {
    content: "\\E052";
  }
  .icon-clock:before {
    content: "\\E053";
  }
  .icon-clock2:before {
    content: "\\E054";
  }
  .icon-tv2:before {
    content: "\\E055";
  }
  .icon-settings2:before {
    content: "\\E056";
  }
  .icon-equalizer:before {
    content: "\\E057";
  }
  .icon-cog:before {
    content: "\\E058";
  }
  .icon-key3:before {
    content: "\\E059";
  }
  .icon-stats:before {
    content: "\\E05A";
  }
  .icon-bars:before {
    content: "\\E05B";
  }
  .icon-fire:before {
    content: "\\E05C";
  }
  .icon-dashboard2:before {
    content: "\\E05D";
  }
  .icon-meter:before {
    content: "\\E05E";
  }
  .icon-power-cord:before {
    content: "\\E05F";
  }
  .icon-brightness-medium:before {
    content: "\\E060";
  }
  .icon-brightness-contrast:before {
    content: "\\E061";
  }
  .icon-heart4:before {
    content: "\\E062";
  }
  .icon-warning2:before {
    content: "\\E063";
  }
  .icon-notification:before {
    content: "\\E064";
  }
  .icon-question3:before {
    content: "\\E065";
  }
  .icon-info3:before {
    content: "\\E066";
  }
  .icon-info4:before {
    content: "\\E067";
  }
  .icon-blocked:before {
    content: "\\E068";
  }
  .icon-cancel-circle:before {
    content: "\\E069";
  }
  .icon-checkmark-circle:before {
    content: "\\E06A";
  }
  .icon-close:before {
    content: "\\E06B";
  }
  .icon-checkmark:before {
    content: "\\E06C";
  }
  .icon-minus3:before {
    content: "\\E06D";
  }
  .icon-plus3:before {
    content: "\\E06E";
  }
  .icon-loop:before {
    content: "\\E06F";
  }
  .icon-loop2:before {
    content: "\\E070";
  }
  .icon-user:before {
    content: "\\F007";
  }
  .icon-chat:before {
    content: "\\E071";
  }
  .icon-socket2:before {
    content: "\\E072";
  }
  .icon-cog2:before {
    content: "\\E073";
  }
  .icon-user2:before {
    content: "\\E074";
  }
  .icon-clock3:before {
    content: "\\E075";
  }
  .icon-key4:before {
    content: "\\E076";
  }
  .icon-unlocked2:before {
    content: "\\E077";
  }
  .icon-lab:before {
    content: "\\E078";
  }
  .icon-search2:before {
    content: "\\F002";
  }
  .icon-cog3:before {
    content: "\\F013";
  }
  .icon-trash:before {
    content: "\\F014";
  }
  .icon-pencil:before {
    content: "\\F040";
  }
  .icon-leaf2:before {
    content: "\\F06C";
  }
  .icon-fire2:before {
    content: "\\F06D";
  }
  .icon-eye-open:before {
    content: "\\F06E";
  }
  .icon-plane:before {
    content: "\\F072";
  }
  .icon-ellipsis-vertical:before {
    content: "\\F073";
  }
  .icon-ellipsis-horizontal:before {
    content: "\\F141";
  }
  .icon-happy:before {
    content: "\\E079";
  }
  .icon-smiley:before {
    content: "\\E07A";
  }
  .icon-happy2:before {
    content: "\\E07B";
  }
  .icon-grin:before {
    content: "\\E07C";
  }
  .icon-grin2:before {
    content: "\\E07D";
  }
  .icon-exit:before {
    content: "\\E07E";
  }
  .icon-shuffle:before {
    content: "\\E07F";
  }
  .icon-planet:before {
    content: "\\E080";
  }
  .icon-file:before {
    content: "\\E081";
  }
  .icon-pin:before {
    content: "\\E082";
  }
  .icon-attachment:before {
    content: "\\E083";
  }
  .icon-pencil2:before {
    content: "\\E084";
  }
  .icon-clipboard:before {
    content: "\\E085";
  }
  .icon-clipboard2:before {
    content: "\\E086";
  }
  .icon-trashcan:before {
    content: "\\E087";
  }
  .icon-cart:before {
    content: "\\E088";
  }
  .icon-bag:before {
    content: "\\E089";
  }
  .icon-lamp:before {
    content: "\\E08A";
  }
  .icon-flag:before {
    content: "\\E08B";
  }
  .icon-vcard:before {
    content: "\\E08C";
  }
  .icon-envelope:before {
    content: "\\F003";
  }
  .icon-film2:before {
    content: "\\F008";
  }
  .icon-download-alt:before {
    content: "\\F019";
  }
  .icon-file2:before {
    content: "\\F016";
  }
  .icon-camera3:before {
    content: "\\F030";
  }
  .icon-screenshot:before {
    content: "\\F05B";
  }
  .icon-folder-close:before {
    content: "\\F07B";
  }
  .icon-folder-open:before {
    content: "\\F07C";
  }
  .icon-wrench:before {
    content: "\\F0AD";
  }
  .icon-beaker:before {
    content: "\\F0C3";
  }
  .icon-list-ul:before {
    content: "\\F0CA";
  }
  .icon-list-ol:before {
    content: "\\F0CB";
  }
  .icon-cloud-download:before {
    content: "\\F0ED";
  }
  .icon-cloud-upload:before {
    content: "\\F0EE";
  }
  .icon-exchange:before {
    content: "\\F0EC";
  }
  .icon-gamepad:before {
    content: "\\F11B";
  }
  .icon-rocket:before {
    content: "\\F135";
  }
  .icon-anchor:before {
    content: "\\F13D";
  }
  .icon-file3:before {
    content: "\\F15B";
  }
  .icon-leaf3:before {
    content: "\\E08D";
  }
  .icon-movie:before {
    content: "\\E08E";
  }
  .icon-music:before {
    content: "\\E08F";
  }
  .icon-gamepad2:before {
    content: "\\E090";
  }
  .icon-drink:before {
    content: "\\E091";
  }
  .icon-drink2:before {
    content: "\\E092";
  }
  .icon-cup:before {
    content: "\\E093";
  }
  .icon-flower:before {
    content: "\\E094";
  }
  .icon-tree:before {
    content: "\\E095";
  }
  .icon-tag:before {
    content: "\\F02B";
  }
  .icon-tags:before {
    content: "\\F02C";
  }
  .icon-map-marker:before {
    content: "\\F041";
  }
  .icon-resize-full:before {
    content: "\\F065";
  }
  .icon-resize-small:before {
    content: "\\F066";
  }
  .icon-move:before {
    content: "\\F047";
  }
  .icon-share:before {
    content: "\\F045";
  }
  .icon-share-alt:before {
    content: "\\F064";
  }
  .icon-check:before {
    content: "\\F046";
  }
  .icon-step-backward:before {
    content: "\\F048";
  }
  .icon-fast-backward:before {
    content: "\\F049";
  }
  .icon-backward:before {
    content: "\\F04A";
  }
  .icon-play:before {
    content: "\\F04B";
  }
  .icon-pause:before {
    content: "\\F04C";
  }
  .icon-stop:before {
    content: "\\F04D";
  }
  .icon-forward:before {
    content: "\\F04E";
  }
  .icon-fast-forward:before {
    content: "\\F050";
  }
  .icon-step-forward:before {
    content: "\\F051";
  }
  .icon-eject:before {
    content: "\\F052";
  }
  .icon-external-link:before {
    content: "\\F08E";
  }
  .icon-filter:before {
    content: "\\F0B0";
  }
  .icon-credit:before {
    content: "\\F09D";
  }
  .icon-sitemap:before {
    content: "\\F0E8";
  }
  .icon-paste:before {
    content: "\\F0EA";
  }
  .icon-desktop:before {
    content: "\\F108";
  }
  .icon-laptop2:before {
    content: "\\F109";
  }
  .icon-tablet:before {
    content: "\\F10A";
  }
  .icon-mobile2:before {
    content: "\\F10B";
  }
  .icon-spinner:before {
    content: "\\F110";
  }
  .icon-location-arrow:before {
    content: "\\F124";
  }
  .icon-microphone:before {
    content: "\\F130";
  }
  .icon-microphone-off:before {
    content: "\\F131";
  }
  .icon-book:before {
    content: "\\F02D";
  }
  .icon-print:before {
    content: "\\F02F";
  }
  .icon-circle-arrow-left:before {
    content: "\\F0A8";
  }
  .icon-circle-arrow-right:before {
    content: "\\F0A9";
  }
  .icon-circle-arrow-up:before {
    content: "\\F0AA";
  }
  .icon-circle-arrow-down:before {
    content: "\\F0AB";
  }
  .icon-globe2:before {
    content: "\\E096";
  }
  .icon-collapse:before {
    content: "\\F150";
  }
  .icon-collapse-top:before {
    content: "\\F151";
  }
  .icon-expand:before {
    content: "\\F152";
  }
  .icon-volume-off:before {
    content: "\\F026";
  }
  .icon-volume-down:before {
    content: "\\F027";
  }
  .icon-volume-up:before {
    content: "\\F028";
  }
  .icon-play-circle:before {
    content: "\\F01D";
  }
  .icon-copy:before {
    content: "\\F0C5";
  }
  .icon-film:before {
    content: "\\E611";
  }
  .icon-lightbulb-on:before {
    content: "\\E612";
  }
  .icon-camera-disconnected:before {
    content: "\\E613";
  }
  .icon-lighting-modules:before {
    content: "\\E615";
  }
  .icon-door2:before {
    content: "\\E616";
  }
  .icon-door-open2:before {
    content: "\\E617";
  }
  .icon-schedule-disabled:before {
    content: "\\E618";
  }
  .icon-schedule-enabled:before {
    content: "\\E619";
  }
  .icon-thermometer:before {
    content: "\\E010";
  }
  .icon-climate:before {
    content: "\\E61A";
  }
  .icon-climate2:before {
    content: "\\E61B";
  }
  .icon-window-open:before {
    content: "\\E61C";
  }
  .icon-window2:before {
    content: "\\E61D";
  }
  .icon-lock-unkown:before {
    content: "\\E61E";
  }
  .icon-sensor-activated2:before {
    content: "\\E61F";
  }
  .icon-sensor2:before {
    content: "\\E620";
  }
  .icon-sensor-activated3:before {
    content: "\\E621";
  }
  .icon-light-switch-on:before {
    content: "\\E622";
  }
  .icon-light-switch-off:before {
    content: "\\E623";
  }
  .icon-home2:before {
    content: "\\E012";
  }
  .icon-lightbulb-off:before {
    content: "\\E600";
  }
  .icon-shades-down2:before {
    content: "\\E614";
  }
  .icon-shades-up2:before {
    content: "\\E626";
  }
  .icon-create-group:before {
    content: "\\E624";
  }
  .icon-nexia-lightning-bolt:before {
    content: "\\E625";
  }
  .icon-wrench2:before {
    content: "\\E097";
  }
  .icon-external-link-sign:before {
    content: "\\F14C";
  }
  .icon-lightbulb-100:before {
    content: "\\E627";
  }
  .icon-lightbulb-60:before {
    content: "\\E628";
  }
  .icon-lightbulb-30:before {
    content: "\\E629";
  }
  .icon-lightbulb-0:before {
    content: "\\E62A";
  }
  .icon-oven:before {
    content: "\\E62B";
  }
  .icon-water-sensor:before {
    content: "\\E62C";
  }
  .icon-sensor-generic-active:before {
    content: "\\E62D";
  }
  .icon-sensor-generic:before {
    content: "\\E62E";
  }
  .icon-switch-house:before {
    content: "\\E62F";
  }
  .icon-warning-sign:before {
    content: "\\F071";
  }
  .icon-critical-cleared:before {
    content: "\\E630";
  }
  .icon-major-cleared:before {
    content: "\\E631";
  }
  .icon-normal-cleared:before {
    content: "\\E632";
  }
  .icon-climate3:before {
    content: "\\E633";
  }
  .icon-climate4:before {
    content: "\\E634";
  }
  .icon-climate5:before {
    content: "\\E635";
  }
  .icon-z-wave:before {
    content: "\\E636";
  }
  .icon-trane-home-logo:before {
    content: "\\E637";
  }
  .icon-water-valve:before {
    content: "\\E638";
  }
  .icon-water-valve-closed:before {
    content: "\\E639";
  }
  .icon-garage-closed:before {
    content: "\\E63A";
  }
  .icon-garage-open:before {
    content: "\\E63B";
  }
  .icon-garage-partial:before {
    content: "\\E63C";
  }
  .icon-battery-low:before {
    content: "\\E601";
  }
  .icon-automation:before {
    content: "\\E63D";
  }
  .icon-nexia-certified:before {
    content: "\\E63E";
  }
  .icon-circled-check:before {
          content: "\\E631";
  }
  .icon-phone-2:before {
    content: "\\E942";
  }
  .icon-envelop:before {
    content: "\\E945";
  }
  .icon-box-add:before {
    content: "\\E95E";
  }
  .icon-box-remove:before {
    content: "\\E95F";
  }
  .icon-filter2:before {
    content: "\\EA5B";
  }
  .icon-note-hollow:before {
    content: "\\E909";
  }
  .icon-note-filled:before {
    content: "\\E90A";
  }
  .icon-minor-alert:before, .icon-minor-sda-alert:before {
    content: "\\E907";
  }
  .icon-critical-alert:before, .icon-major-alert:before, .icon-major-sda-alert:before {
    content: "\\E906";
  }
  .icon-display-day-rth:before {
    content: "\\E90B";
  }
  .icon-device-reset:before {
    content: "\\E908"
  }
  .icon-snapshot-received:before {
    content: "\\E90C"
  }
  .icon-arrow-up-stem-skinny:before {
    content: "\\EA3A";
  }
  .icon-arrow-right-stem-skinny:before {
    content: "\\EA3C";
  }
  .icon-arrow-down-stem-skinny:before {
    content: "\\EA3E";
  }
  .icon-arrow-left-stem-skinny:before {
    content: "\\EA40";
  }
  .icon-updates:before {
    content: "\\E900";
  }
  .icon-add-customer:before {
    content: "\\E901";
  }
  .icon-alert-guide:before {
    content: "\\E902";
  }
  .icon-customers:before {
    content: "\\E903";
  }
  .icon-dashboard:before {
    content: "\\\E904";
  }
  .icon-notifications:before {
    content: "\\E905";
  }
  .icon-message:before {
    content: "\\E90D";
  }
  .icon-aggregation:before {
    content: "\\E90E";
  }
  .icon-search-nav:before {
    content: "\\E90F";
  }
  .icon-favorites:before {
    content: "\\E910";
  }
  .icon-warranty-lookup:before {
    content: "\\E911";
  }

  .icon-critical-alert {
    color: ${color('criticalAlert')};
  }
  .icon-major-alert {
    color: ${color('majorAlert')};
  }
  .icon-minor-alert {
    color: ${color('minorAlert')};
  }
  .icon-major-sda-alert {
    color: ${color('majorSdaAlert')};
  }
  .icon-minor-sda-alert {
    color: ${color('minorSdaAlert')};
  }
}

`
